import { ACTION_TYPE } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { EntitlementShare } from './models';
import { apiGetEntitlementShares } from '../../core/redux/api/endpoints';
import { assoc } from '../../language/module';


export const KEY_ACTION = ACTION_TYPE.ENTITLEMENT_SHARES_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.ENTITLEMENT_SHARES_REQUEST,
  ACTION_TYPE.ENTITLEMENT_SHARES_RESPONSE,
  ACTION_TYPE.ENTITLEMENT_SHARES_ERROR,
];


/**
 * Constructs an action that can be dispatched to get a guest's entitlement share history.
 * @param guestId - the guest whose entitlement shares we want to fetch
 */
export const getEntitlementSharesAction = (guestId: string) => {
  return makeApiAction(
    {
      method:   'GET',
      headers:  (state: IAppState) => ({
        'content-type':  'application/json',
        'Authorization': `Bearer ${state.auth.bearerToken}`,
      }),
      endpoint: apiGetEntitlementShares(guestId),
      types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
      bailout:  (state: IAppState) => !!getLoading(state, guestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
    },
  );
}


const reducer: ApiReducer<EntitlementShare[]> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId!, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId!, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId!, KEY_ACTION);

  // Put the Guest ID on each entitlement share object
  const newEntries = (payload || []).map(item => assoc('guestId', guestId, item));

  return assoc(
    'entitlementShares',
    newEntries.concat(
      noLoadingOrError.entitlementShares.filter((share: EntitlementShare) => share.guestId !== guestId),
    ),
    noLoadingOrError,
  );
};


export const getEntitlementSharesReducer = makeApiReducer<EntitlementShare[]>(ACTIONS, KEY_ACTION, reducer);
